import React from 'react';

const TasksPage = ({ active, tasks, onAddTask, onToggleTask, onDeleteTask }) => (
  <section className={`section ${active ? 'active' : ''}`} data-testid="tasks-section">
    <div className="section-header">
      <div>
        <div className="section-title">Tasks & Activities</div>
        <div className="section-subtitle">Manage your daily calls, emails, and meetings</div>
      </div>
      <button className="btn btn-gold" onClick={onAddTask} data-testid="open-add-task-btn">+ New Task</button>
    </div>
    <div className="glass-panel">
      <div className="glass-panel-header">
        <div className="glass-panel-title">TODAY'S AGENDA</div>
      </div>
      <div className="panel-body" style={{ padding: '16px' }}>
        <div className="task-list">
          {tasks.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '20px', color: 'var(--text-muted)', fontSize: '13px' }}>
              Tidak ada task yang dijadwalkan.
            </div>
          ) : (
            [...tasks].sort((a, b) => (a.date + a.time).localeCompare(b.date + b.time)).map(t => (
              <div
                key={t.id}
                className={`task-item ${t.done ? 'completed' : ''}`}
                onClick={() => onToggleTask(t)}
                data-testid={`task-item-${t.id}`}
              >
                <div className={`task-checkbox ${t.done ? 'checked' : ''}`}>✓</div>
                <div className="task-info">
                  <div className="task-title">{t.title}</div>
                  <div className="task-meta">
                    <span title="Tanggal">📅 {t.date}</span>
                    <span title="Waktu">🕒 {t.time}</span>
                    <span className="task-tag">{t.tag}</span>
                  </div>
                </div>
                <button
                  className="task-delete-btn"
                  onClick={(e) => { e.stopPropagation(); onDeleteTask(t.id); }}
                  title="Hapus Task"
                  data-testid={`delete-task-btn-${t.id}`}
                >✕</button>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  </section>
);

export default TasksPage;
